module.exports = __webpack_public_path__ + "assets/img/3207.89baf0b2.png";